export default __webpack_public_path__ + "static/media/updated-ISKO.d4405b8a.pdf";